import React, { useEffect, useState } from 'react';
import styles from '../../src/assets/scss/AddNewUsers.module.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import Pagination from '../Components/Common/Pagination';
import { FaTrash } from 'react-icons/fa';
import DeleteConfirmModal from '../Components/Common/DeleteConfirmModal';
import { useCreateUserMutation, useGetUserBasedRolesQuery, useUpdateUserMutation } from '../slices/admin/admin';
import { toast } from 'react-toastify';
import Select from 'react-select';

const AddNewUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || 'add';
  const isEdit = mode === 'edit';
  const editData = location.state?.data || {};
  const [isModalOpen, setModalOpen] = useState(false);

  const [createUser] = useCreateUserMutation();
  const { data: rolesData, isLoading } = useGetUserBasedRolesQuery();



  console.log(rolesData, "rolesDatarolesDatarolesDatarolesData");



  const [updateUser] = useUpdateUserMutation();


  const [formData, setFormData] = useState({
    userName: editData.userName || '',
    type: editData.type || '',
    firstName: editData.firstName || '',
    lastName: editData.lastName || '',
    isActive: editData.isActive !== undefined ? String(editData.isActive) : '',
    phone: editData.phone || '',
    appAccess: editData.appAccess !== undefined ? String(editData.appAccess) : '',
    deviceId: editData.deviceId || '',
    paymentThreshold: editData.paymentThreshold || '',
    paymentType: editData.paymentType || '',
  });






  const [deleteIndex, setDeleteIndex] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  useEffect(() => {
    if (isEdit && editData.roles?.length > 0) {
      const mappedRoles = editData.roles.map(role => ({
        roleId: role._id,
        roleName: role.roleName,
        description: role.description
      }));
      setSelectedRoles(mappedRoles);
    }
  }, [isEdit, editData.roles]);


  const preventLeadingSpace = (e) => {
    if (e.target.selectionStart === 0 && e.key === " ") e.preventDefault();
  };

  const phoneKeyDown = (e) => {
    const invalidKeys = ['e', 'E', '+', '-', '.', ' '];
    if (invalidKeys.includes(e.key) || (e.target.selectionStart === 0 && ['1', '2', '3', '4', '5'].includes(e.key))) {
      e.preventDefault();
    }
  };

  const phoneInputHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    handleChange({ target: { name: 'phone', value } });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  // const validate = () => {
  //   const newErrors = {};
  //   Object.entries(formData).forEach(([key, value]) => {
  //     if (!value.trim()) newErrors[key] = 'This field is required';
  //   });
  //   if (formData.phone && !/^[6-9][0-9]{9}$/.test(formData.phone)) {
  //     newErrors.phone = 'Phone number must start with 6–9 and be 10 digits';
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validate = () => {
    const newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "deviceId") return;

      if (!value.trim()) newErrors[key] = "This field is required";
    });

    if (formData.phone && !/^[6-9][0-9]{9}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must start with 6–9 and be 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        ...formData,
        isActive: formData.isActive === 'true',
        appAccess: formData.appAccess === 'true',
        roleIds: selectedRoles.map(role => role.roleId),
      };

      if (isEdit) {
        updateUser({
          id: editData._id,
          data: payload,
        })
          .unwrap()
          .then((res) => {
            toast.success(res.message || 'User updated successfully');
            navigate('/dashboard/Users');
          })
          .catch((err) => {
            toast.error(err?.data?.message || 'Failed to update user');
          });
      } else {
        createUser(payload)
          .unwrap()
          .then((res) => {
            toast.success(res.message || 'User created successfully');
            navigate('/dashboard/Users');
          })
          .catch((err) => {
            toast.error(err?.data?.message || 'Failed to create user');
          });
      }
    }
  };


  const handleAddRole = () => {
    setSelectedRoles(prev => [
      ...prev,
      {
        roleId: '',
        roleName: '',
        description: ''
      }
    ]);
  };




  const handleRowsChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setModalOpen(true);
  };

  const confirmDelete = () => {
    if (deleteIndex !== null) {
      const updated = selectedRoles.filter((_, i) => i !== deleteIndex);
      setSelectedRoles(updated);
      setDeleteIndex(null);
      setModalOpen(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>{isEdit ? 'Update User' : 'Add New User'}</h2>
        <span className={styles.closeIcon} onClick={() => navigate(-1)}>✕</span>
      </div>

      <form className={styles.formGrid}>
        <div>
          <label className={styles.inputLabel}>User Name</label>
          <input placeholder='User Name' name="userName" className={styles.input} type="text" value={formData.userName} onChange={handleChange} onKeyDown={preventLeadingSpace} />
          {errors.userName && <span className={styles.error}>{errors.userName}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>User Type</label>
          <select name="type" className={styles.inputs} value={formData.type} onChange={handleChange}>
            <option value="">Select User Type</option>
            <option value="employee">Employee</option>
          </select>
          {errors.type && <span className={styles.error}>{errors.type}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>First Name</label>
          <input placeholder='First Name' name="firstName" className={styles.input} type="text" value={formData.firstName} onChange={handleChange} onKeyDown={preventLeadingSpace} />
          {errors.firstName && <span className={styles.error}>{errors.firstName}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>Last Name</label>
          <input name="lastName" placeholder='Last Name' className={styles.input} type="text" value={formData.lastName} onChange={handleChange} onKeyDown={preventLeadingSpace} />
          {errors.lastName && <span className={styles.error}>{errors.lastName}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>User Status</label>

          <select name="isActive" className={styles.inputs} value={formData.isActive} onChange={handleChange}>
            <option value="">Select Status</option>
            <option value="true">Active</option>
            <option value="false">In Active</option>
          </select>

          {errors.isActive && <span className={styles.error}>{errors.isActive}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>Phone Number</label>
          <input name="phone" placeholder='Phone Number' className={styles.input} type="text" value={formData.phone} onKeyDown={phoneKeyDown} onInput={phoneInputHandler} maxLength={10} />
          {errors.phone && <span className={styles.error}>{errors.phone}</span>}
        </div>

        <div>
          <label className={styles.inputLabel}>App Access</label>
          <select name="appAccess" className={styles.inputs} value={formData.appAccess} onChange={handleChange}>
            <option value="">Select Status</option>
            <option value={true}>Yes</option>
            <option value={false}>No</option>
          </select>
          {errors.appAccess && <span className={styles.error}>{errors.appAccess}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>Device ID</label>
          <input name="deviceId" placeholder='Device ID' className={styles.input} type="text" value={formData.deviceId} onChange={handleChange} onKeyDown={preventLeadingSpace} />
          {errors.deviceId && <span className={styles.error}>{errors.deviceId}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>Payment Threshold</label>
          <select name="paymentThreshold" className={styles.inputs} value={formData.paymentThreshold} onChange={handleChange}>
            <option value="">Select Threshold</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
          {errors.paymentThreshold && <span className={styles.error}>{errors.paymentThreshold}</span>}
        </div>
        <div>
          <label className={styles.inputLabel}>Payment Details</label>
          <select name="paymentType" className={styles.inputs} value={formData.paymentType} onChange={handleChange}>
            <option value="">Select Method</option>
            <option value="upi">UPI</option>
            <option value="cash">Cash</option>
          </select>
          {errors.paymentType && <span className={styles.error}>{errors.paymentType}</span>}
        </div>
      </form>


      <div className={styles.roleContainer}>
        <div className={styles.footerButtons}>
          <button className={styles.saves} type="button" onClick={handleAddRole}>
            + Add Roles
          </button>
        </div>

        <div className={styles.roleTable}>
          <div className={styles.tableHeader}>
            <div className={styles.checkbox}><input type="checkbox" /></div>
            <div>Role Name</div>
            <div>Role Description</div>
            <div></div>
          </div>

          {selectedRoles.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((roleEntry, index) => (
            <div className={styles.tableRow} key={index}>
              <div className={styles.checkbox}><input type="checkbox" /></div>

              <div>
                <Select
                  isDisabled={isLoading}
                  value={roleEntry.roleId ? {
                    value: roleEntry.roleId,
                    label: rolesData?.data?.find(r => r._id === roleEntry.roleId)
                      ? `${rolesData.data.find(r => r._id === roleEntry.roleId).roleName} - [${rolesData.data.find(r => r._id === roleEntry.roleId).description}]`
                      : "Select Role"
                  } : null}
                  onChange={(selectedOption) => {
                    const selected = selectedOption ? rolesData?.data?.find(r => r._id === selectedOption.value) : null;
                    const updatedRoles = [...selectedRoles];
                    updatedRoles[index] = {
                      roleId: selected?._id || '',
                      roleName: selected?.roleName || '',
                      description: selected?.description || ''
                    };
                    setSelectedRoles(updatedRoles);
                  }}
                  options={rolesData?.data?.map(role => ({
                    value: role._id,
                    label: `${role.roleName} - [${role.description}]`
                  })) || []}
                  placeholder={isLoading ? "Loading..." : "Search and Select Role"}
                  isSearchable
                  isClearable
                  menuPortalTarget={document.body}
                  menuPosition={'fixed'}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "1px solid #6D6D6D",
                      borderRadius: "6px",
                      fontSize: "16px",
                      minHeight: "50px",
                      boxShadow: "none",
                      color: "black",
                      fontWeight: "600",
                      width: "500px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6D6D6D",
                      fontSize: "16px",
                      fontWeight: "600",
                    }),
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>

              <div>{roleEntry.description}</div>

              <div>
                <FaTrash
                  className={styles.deleteIcon}
                  onClick={() => handleDeleteClick(index)}
                />
              </div>
            </div>
          ))}
        </div>

        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(selectedRoles.length / rowsPerPage)}
            onPageChange={setCurrentPage}
          />
          <select className={styles.inputsbtn} value={rowsPerPage} onChange={handleRowsChange}>
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>

        <div className={styles.footerButtons}>
          <button type="button" className={styles.cancel} onClick={() => navigate(-1)}>Cancel</button>
          <button type="submit" onClick={handleSubmit} className={styles.save}>
            {isEdit ? 'Update' : 'Save'}
          </button>
        </div>
      </div>


      <DeleteConfirmModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
      />
    </div>
  );
};

export default AddNewUsers;
